import {
  checkIfLocalTurnAction,
  checkIfTurnInputBlocked,
  notifyTurnInputBlocked,
} from '../../utils/gameState/turn/turnInputLock';

/**
 * Страж блокировки ввода после нуля таймера хода (сетевая партия, см.
 * utils/gameState/turn/turnInputLock).
 *
 * Пока блокировка действует, игровое действие игрока не применяется у него и
 * не уходит на сервер: в ход, который сервер вот-вот закроет, оно бы не успело
 * и вернулось отказом с полной перерисовкой поля. Игрок получает подсказку
 * «Время хода вышло».
 *
 * Не трогает: пришедшее с сервера (_fromServer), локальные экшены интерфейса
 * (noServerSync), чат и служебные экшены (checkIfLocalTurnAction), действия
 * ботов, которые исполняет этот клиент (область работы бота).
 *
 * Стоит ПЕРВЫМ в цепочке: отброшенный экшен не должен увидеть никто — ни
 * анимация перемещения (она добивает полет отряда на любом игровом экшене), ни
 * отправка на сервер. Это последний рубеж: входы с побочными эффектами (клик
 * по полю, кнопка завершения хода, handleCompleteTurn) проверяют блокировку
 * сами, до своих звуков и подсказок.
 */
const turnInputGuardMiddleware = (store) => (next) => (action) => {
  if (!checkIfLocalTurnAction(action)) {
    return next(action);
  }
  const state = store.getState();
  if (!checkIfTurnInputBlocked(state)) {
    return next(action);
  }
  notifyTurnInputBlocked(store.dispatch, state);
  return action;
};

export default turnInputGuardMiddleware;
